<template>
  <div class="my-medal">
    <div class="top-div">
      <div class="header-con">
        <img :src="userInfo && userInfo.headPicUrl" class="head-cover" alt="">
        <div class="con-block">
          <div class="con-txt1">{{ userInfo && userInfo.realName }}</div>
          <div class="con-txt2">已获得{{ medalList.length > 0 ? medalList.length : 0 }}枚勋章</div>
        </div>
      </div>
    </div>
    <div class="div-section">
      <div class="sec-top">
        <img src="@/assets/images/training/img(2).png" class="icon-sec icon-sec-left" alt="">
        <span class="sec-top-txt">成长徽章</span>
        <img src="@/assets/images/training/img(1).png" class="icon-sec icon-sec-right" alt="">
      </div>
    </div>
    <div class="div-block">
      <!-- <div class="div-item" v-for="(item, index) in medalList" :key="item.id+index">
        <template v-if="`${item.medalLevel}` === '1'">
          <img src="@/assets/images/training/img(19).png" class="item-cover" alt="">
          <div class="item-txt">连登先锋</div>
        </template>
        <template v-if="`${item.medalLevel}` === '2'">
          <img src="@/assets/images/training/img(17).png" class="item-cover" alt="">
          <div class="item-txt">知识富翁</div>
        </template>
        <template v-if="`${item.medalLevel}` === '3'">
          <img src="@/assets/images/training/img(18).png" class="item-cover" alt="">
          <div class="item-txt">博观约取</div>
        </template>
        <template v-if="`${item.medalLevel}` === '4'">
          <img src="@/assets/images/training/img(21).png" class="item-cover" alt="">
          <div class="item-txt">学海领航</div>
        </template>
        <template v-if="`${item.medalLevel}` === '5'">
          <img src="@/assets/images/training/img(20).png" class="item-cover" alt="">
          <div class="item-txt">心电大师</div>
        </template>
      </div> -->
      <div class="div-item" v-for="(item, index) in defaultMedal" :key="index">
        <template v-if="`${item.level}` === '1'">
          <img src="@/assets/images/training/img(37).png" v-if="!item.isChecked" class="item-cover" alt="">
          <img src="@/assets/images/training/img(19).png" v-else class="item-cover" alt="">
          <div class="item-txt">连登先锋</div>
        </template>
        <template v-if="`${item.level}` === '2'">
          <img src="@/assets/images/training/img(38).png" v-if="!item.isChecked" class="item-cover" alt="">
          <img src="@/assets/images/training/img(17).png" v-else class="item-cover" alt="">
          <div class="item-txt">知识富翁</div>
        </template>
        <template v-if="`${item.level}` === '3'">
          <img src="@/assets/images/training/img(39).png" v-if="!item.isChecked" class="item-cover" alt="">
          <img src="@/assets/images/training/img(18).png" v-else class="item-cover" alt="">
          <div class="item-txt">博观约取</div>
        </template>
        <template v-if="`${item.level}` === '4'">
          <img src="@/assets/images/training/img(40).png" v-if="!item.isChecked" class="item-cover" alt="">
          <img src="@/assets/images/training/img(21).png" v-else class="item-cover" alt="">
          <div class="item-txt">学海领航</div>
        </template>
        <template v-if="`${item.level}` === '5'">
          <img src="@/assets/images/training/img(41).png" v-if="!item.isChecked" class="item-cover" alt="">
          <img src="@/assets/images/training/img(20).png" v-else class="item-cover" alt="">
          <div class="item-txt">心电大师</div>
        </template>
      </div>
    </div>
    <div class="div-section pd-t-0">
           <div class="sec-top">
           <img src="@/assets/images/training/img(2).png" class="icon-sec icon-sec-left" alt="">
            <span class="sec-top-txt">限定徽章</span>
            <img src="@/assets/images/training/img(1).png" class="icon-sec icon-sec-right" alt="">
           </div>
        </div>
     <div class="div-block">
      <div class="div-item" v-for="(item, index) in limitedMedalList" :key="index">
        <template v-if="`${item.level}` === '2025'">
          <img src="@/assets/images/training/img(59).png" v-if="!item.isChecked" class="item-cover" alt="">
          <img src="@/assets/images/training/img(60).png" v-else class="item-cover" alt="">
          <div class="item-txt">iEP 2025</div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserMedal } from '../../api/person'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      medalList: [],
      defaultMedal: [{
        level: 1,
      }, {
        level: 2,
      }, {
        level: 3,
      }, {
        level: 4,
      }, {
        level: 5,
      }],
      defaultArr: [],
      limitedMedalList: [{
        level: 2025
      }]
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    getUserMedal({ userId: this.userInfo.id }).then(res => {
      this.medalList = res.data
      this.defaultMedal = this.defaultMedal.map(item => {
        item.isChecked = false
        res.data.map(itm => {
          if (item.level === itm.medalLevel) {
            item.isChecked = true
          }
        })
        return item
      })
      this.limitedMedalList = this.limitedMedalList.map(item => {
        item.isChecked = false
        res.data.map(itm => {
          if (item.level === itm.medalLevel) {
            item.isChecked = true
          }
        })
        return item
      })
      // let noHas = res.data.map(ite => ite.medalLevel)
      // this.defaultArr = this.defaultMedal.filter(item => !noHas.includes(item))
    })
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.my-medal {
  .top-div {
    width: 100%;
    height: 122px;
    background: url('~@/assets/images/person/my-medal-top-div-bg.png') no-repeat center center / 100% 100%;

    .header-con {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 76px;

      .head-cover {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: block;
        margin-bottom: 6px;
      }

      .con-txt1 {
        font-size: 16px;
        line-height: 20px;
        margin-bottom: 4px;
        color: #000;
        text-align: center;
      }

      .con-txt2 {
        font-size: 10px;
        line-height: 14px;
        color: #6D779E;
        text-align: center;
      }
    }
  }

  .div-section {
    padding-top: 84px;

    .sec-top {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 17px;
      box-sizing: border-box;

      .icon-sec {
        width: 121px;
        height: 24px;
      }

      .sec-top-txt {
        width: 70px;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #000000;
      }
    }
  }
  .pd-t-0{
    padding-top: 0;
  }

  .div-block {
    display: flex;
    flex-wrap: wrap;
    padding: 0 35px;
    box-sizing: border-box;

    &.mar-top {
      margin-top: 40px;
    }

    .div-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 17px;

      &:nth-child(3n-1) {
        margin: 0 20px;
      }

      .item-cover {
        width: 87px;
        height: 74px;
        display: block;
        margin-bottom: 4px;
      }
      .item-cover-limited {
        width: 87px;
        height: 87px;
        display: block;
        transform: translateY(-21px) scale(1.35);
      }

      .item-txt {
        color: rgba(0, 0, 0, 0.6);
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/myMedal.vue